import { ScheduledActivityType } from './Utils';

export interface Activity {
  id: number;
  date: string;
  actorName: string;
  type: ActivityType;
  description: string;
  isImportant: boolean;
  isTemporary?: boolean;
  scheduled?: string;
  status?: ActivityStatus;
  isAI?: boolean;
}

export interface AddActivityDto {
  activityType: number;
  description: string;
  activityTime: string | null;
}

export interface EditActivity {
  isImportant?: boolean;
  activityTime?: string;
  status?: ActivityStatus;
  scheduledDate?: Date;
}

export enum ActivityType {
  'Creation Event' = 1,
  'Incoming Email' = 2,
  'Outgoing Email' = 3,
  'Incoming Message' = 4,
  'Outgoing Message' = 5,
  'Incoming Phone Call' = 6,
  'Outgoing Phone Call' = 7,
  Note = 8,
  'Status Change' = 9,
  'Stage Change' = 10,
  'Schedule Call' = 11,
  'Edit' = 21,
  Dsi = 23,

  // 'Send Email' = 2, // temporarily removed ?
}

export enum ActivityStatus {
  'pending' = 1,
  'completed' = 2,
  'cancelled' = 3,
}
export type ActivityTypeName = keyof typeof ActivityType;

export type ActivityTypeObject = {
  id: ActivityType;
  name: ActivityTypeName;
};

export interface ActivitySummary {
  count: number;
  date: Date;
  activities: {
    [K in keyof typeof ScheduledActivityType]: number;
  };
}

export type EventGroup = 'task' | 'note' | 'statusChange' | 'system';

export enum EventType {
  CreationEvent = 1,
  IncomingEmail = 2,
  OutgoingEmail = 3,
  IncomingMessage = 4,
  OutgoingMessage = 5,
  IncomingPhoneCall = 6,
  OutgoingPhoneCall = 7,
  Note = 8,
  StatusChange = 9,
  StageChange = 10,
  Scheduled = 11,
  FollowUp = 12,
  Call = 13,
  Text = 14,
  Email = 15,
  Reminder = 16,
  Other = 17,
  Snooze = 18,
  VaultUpdated = 19,
  VaultLinkSent = 20,
  Edit = 21,
  System = 22,
  Dsi = 23,
}
